export default __webpack_public_path__ + "static/chessNew-9d9aaba891b14cc7a2e933d0d3a73d1a.jpg";